import type { Input } from "./types";

export default class extends Marko.Component<Input> {
  onItemHover(markerIndex: number, listingId: string) {
    this.emit("item-hover", markerIndex, listingId);
  }

  onUnhoverItem() {
    this.emit("unhover-item");
  }
}
